export enum JudgeStatus {
  NOT_START = 0,
  VOTING,
  VOTE_DONE, // 在评审详情里打分完毕的状态
  TIMEOUT,
  DONE // 在列表页投票完毕的状态
}

export enum ReviewTemplateType {
  SCORE = 1,
  MATRIX,
}

export enum JudgeSelection {
  NO = 0,
  YES,
}

export enum OperatorType {
  Self,
  Delegation
}
